import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";
import { useTranslation } from "react-i18next";

import type { UiTheme } from "../../theme";
import { measurementTitleStyle } from "./MeasurementTrendChart";

type Props = {
  title: string;
  /** Label of the only point, when there is exactly one. */
  lastLabel?: string;
  theme: UiTheme;
};

// A series too short to chart (0 or 1 point): its title plus a plain line,
// so the metric never just disappears (#151).
export function MeasurementEmptyRow({ title, lastLabel, theme }: Props) {
  const { t } = useTranslation();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  const line =
    lastLabel !== undefined
      ? t("common.lastDataOn", {
          date: lastLabel,
          defaultValue: "Last data: {{date}}",
        })
      : t("common.noData", { defaultValue: "No data" });
  return (
    <View
      style={styles.row}
      accessible
      accessibilityLabel={`${title}, ${line}`}
    >
      <Text style={measurementTitleStyle(theme)}>{title}</Text>
      <Text style={styles.line}>{line}</Text>
    </View>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return StyleSheet.create({
    row: { gap: s.s1, marginTop: s.s3 },
    line: { color: p.ink3, fontSize: ty.sizes.sm },
  });
}
